import { functions } from '../../../config/firebase'
import { getCallableErrorMessage } from '../../ProductsSyncMenu/syncDateUtils'

/**
 * Staff callable: paginated promo codes for one Ame campaign.
 * @param {{ campaignId: string, filter?: 'all'|'used', limit?: number, cursor?: number|null }} payload
 */
const listAmeCampaignPromoCodes = async (payload = {}) => {
  try {
    const callable = functions.httpsCallable('listAmeCampaignPromoCodes')
    const result = await callable(payload)
    return { ok: true, data: result.data }
  } catch (error) {
    console.error('[listAmeCampaignPromoCodes] failed:', error)
    return {
      ok: false,
      message: getCallableErrorMessage(error),
      code: error?.code || null,
    }
  }
}

export default listAmeCampaignPromoCodes
